import axios from "axios"
import { URL_BASE, NAME_TOKEN, URL_COOKIE } from '../../../config/config'

// Habilita envio de cookies em requisições cross-origin
axios.defaults.withCredentials = true

const RESOURCE = 'users'

export default {
    state: {
        me: {},
        authenticated: false,
        urlBack: 'login',
    },

    mutations: {
        AUTH_USER_OK (state, user) {
            state.authenticated = true,
            state.me = user
        },

        AUTH_USER_LOGOUT (state) {
            state.me = {},
            state.authenticated = false,
            state.urlBack = 'login'
        },

        CHANGE_URL_BACK (state, url) {
            state.urlBack = url
        },

        REFRESH_ME (state, user) {
            state.me = user
        },
    },

    actions: {
        async login({ commit, dispatch }, params) {
            // Nota: Adicionei { root: true } caso PRELOADER seja global
            commit('PRELOADER', true, { root: true }) 
            
            try {
                // Passo 1: CSRF Protection (Sanctum)
                await axios.get(URL_COOKIE);

                // Passo 2: Login
                // Nota: O Laravel Sanctum geralmente retorna 204 (No Content) ou 200 no login
                await axios.post(`${URL_BASE}auth`, params)
                
                // Passo 3: Após login, buscamos os dados do usuário
                // É mais seguro buscar o 'me' agora do que confiar no retorno do login
                await dispatch('checkLogin')
                
            } catch (error) {
                console.log(error);
                // Se der erro no login, propagamos o erro para o componente tratar
               // throw error
            } finally {
                commit('PRELOADER', false, { root: true })
            }
        },

        async checkLogin (context) {
            context.commit('PRELOADER', true)
            try {
                const url = URL_BASE + 'me'
                const response = await axios.get(url)
                context.commit('AUTH_USER_OK', response.data.data)
            } catch (error) {
                context.dispatch('logout')
                throw error // <--- OBRIGATÓRIO: Avisa o Router que falhou
            } finally {
                context.commit('PRELOADER', false)
            }
        },

        // 3. Logout
        async logout (context) {
            context.commit('PRELOADER', true)
            try {
                console.log(URL_BASE + 'logout');
                await axios.post(URL_BASE + 'logout')
            } catch (e) {
                console.warn('Logout API failed')
            } finally {
                context.commit('AUTH_USER_LOGOUT')
                window.location.href = "/login"
                context.commit('PRELOADER', false)
            }    
        },

        // 4. Refresh (se necessário)
        async refreshMe (context, id) {
            context.commit('PRELOADER', true)
            try {
                const response = await axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                context.commit('AUTH_USER_OK', response.data.data)
            } finally {
                context.commit('PRELOADER', false)
            }
        },
        
    },
}